"use client";

import Image from "next/image";
import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";

import {
  Text,
  TextColor,
  TextSize,
  TextVariant,
  TextWeight,
} from "../../components/Text";

interface CmsCarouselProps {
  title: string;
  images: {
    src: string;
    alt: string;
  }[];
}

export const CmsCarousel: React.FC<CmsCarouselProps> = ({ title, images }) => {
  const sliderRef = useRef<Slider>(null);

  // Minimalne ustawienia slidera
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    adaptiveHeight: false,
  };

  // Blokowanie menu kontekstowego (prawy przycisk myszy)
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <StyledCmsCarousel>
      <Text
        text={title}
        variant={TextVariant.H1}
        color={TextColor.BLACK}
        weight={TextWeight.BOLD}
        fontSize={TextSize.XXXL}
        className="mb-8"
      />

      <div className="mb-8 w-full flex justify-start">
        <Slider ref={sliderRef} {...sliderSettings}>
          {images.map((image, index) => (
            <div key={index} className="outline-none">
              <div className="px-2">
                <Image
                  src={image.src}
                  alt={image.alt}
                  width={1200}
                  height={800}
                  className="w-full h-auto object-contain rounded-lg"
                  priority={index === 0}
                  style={{
                    maxHeight: "70vh",
                    objectFit: "contain",
                  }}
                  onContextMenu={(e) => e.preventDefault()} // Dodatkowa blokada na obrazach
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </StyledCmsCarousel>
  );
};

const StyledCmsCarousel = styled.div`
  .slick-slider {
    width: 100%;
  }

  .slick-dots {
    bottom: -40px;
  }

  .slick-dots li {
    margin: 0 2px;
  }

  .slick-dots li button:before {
    font-size: 10px;
    color: #cbd5e0;
    opacity: 0.7;
  }

  .slick-dots li.slick-active button:before {
    color: #4a5568;
    opacity: 1;
  }

  .slick-prev,
  .slick-next {
    z-index: 10;
  }

  .slick-slide {
    padding: 0 2px;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    .slick-dots {
      bottom: -30px;
    }

    .slick-dots li button:before {
      font-size: 8px;
    }
  }
`;
